import { TweenMax } from 'gsap';
import ProgressLoader from '../plugins/progressLoader';
import ImageNavigator from '../plugins/imageNavigator';

class Detail {

	constructor() {

		this.preventDefault		= this.preventDefault.bind(this);
		this.navClickHandler	= this.navClickHandler.bind(this);
		this.resizeHandler		= this.resizeHandler.bind(this);
		this.loadCallback		= this.loadCallback.bind(this);
		this.wishlistToggle 	= this.wishlistToggle.bind(this);
		this.closeWishlistAlert	= this.closeWishlistAlert.bind(this);

		if ($('.Detail').length) {
			this.init();
		}

	}

	preventDefault(e) {
		e.preventDefault();
	}

	init() {

		// initialization

		this.iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

		this.$window = $(window);
		this.$area = $('.Detail');
		this.$nav = $('.Detail__Nav button');
		this.$img = $('.Detail__Image img');
		this.$loader = $('.Detail__Loader div');
		this.$wishlistForm = $('.Detail__Wishlist');
        this.$wishlistAlert = $('.Detail__WishlistAlert');

		// trigger

		this.resizeHandler();

		// events binding

		this.$window.on('load', this.resizeHandler);
		this.$window.on('resize', this.resizeHandler);
		this.$nav.on('click', this.navClickHandler);
		this.$wishlistForm.on('submit', this.wishlistToggle);
		this.$wishlistAlert.find('button').on('click', this.closeWishlistAlert);

		this.imageNavigator = new ImageNavigator(this.$area[0]);

	}

	resizeHandler() {

		if (this.iOS) {
			this.$area.height(this.$window.height() - 200);
		}

	}

	navClickHandler(e) {

		e.preventDefault();
		this.$nav.off('click', this.navClickHandler);

		this.$nav.removeClass('active');
		$(e.currentTarget).addClass('active');

		TweenMax.to(this.$img, 0.3, {
			opacity: 0
		});

		delete this.imageNavigator;

		this.showLoader();
		setTimeout(() => {
			this.loadImage(e.currentTarget.dataset.image);
		}, 500);

	}

	showLoader() {

		this.$loader.css('width', 0);
		this.$area.addClass('Detail--loading');

	}

	hideLoader() {

		this.$area.removeClass('Detail--loading');
		setTimeout(() => {
			this.$loader.css('width', 0);
		}, 500);

	}

	loadImage(src) {

		const loader = new ProgressLoader(src, {
			onProgress: (perc) => {
				this.$loader.css('width', `${perc}%`);
			},
			onComplete: this.loadCallback
		});

	}

	loadCallback(src) {

		setTimeout(() => {

			this.hideLoader();
			this.$img.attr('src', src);
			this.$img.removeAttr('width');
			this.$img.removeAttr('height');
			this.imageNavigator = new ImageNavigator(this.$area[0]);
			this.$nav.on('click', this.navClickHandler);

			setTimeout(() => {
				this.resizeHandler();
			}, 100);

            TweenMax.to(this.$img, 0.3, {
                x: 0,
                y: 0,
                opacity: 1,
                delay: 0.3
            });


		}, 300);

	}

    wishlistToggle(e) {

        e.preventDefault();
        const form = $(e.currentTarget);

        $.post(form.attr('action'), form.serialize(), response => {
            if(response.action === 'removed') {
                this.$wishlistAlert.find('p').text(this.$wishlistAlert.find('p').data('removed'));
				form.removeClass('Detail__Wishlist--added');
                form.find('[type="submit"]').text(form.data('add-text'));
            } else {
                this.$wishlistAlert.find('p').text(this.$wishlistAlert.find('p').data('added'));
				form.addClass('Detail__Wishlist--added');
                form.find('[type="submit"]').text(form.data('remove-text'));
            }

            setTimeout(() => {
                this.$wishlistAlert.addClass('show');
            }, 50)

            setTimeout(() => {
                this.$wishlistAlert.removeClass('show');
            }, 2000)
        })

    }

    closeWishlistAlert() {

        this.$wishlistAlert.removeClass('show');

    }

}

export default new Detail();



// WEBPACK FOOTER //
// ./js/layouts/detail.js